var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._m(0),_c('ConfigurationCard',{attrs:{"data":_vm.data},on:{"showChat":_vm.showChat}}),_c('BgRadialScrew')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v("Visualizza Userbot"),_c('br'),_vm._v("direttamente sul tuo sito web")])
}]

export { render, staticRenderFns }